
export default {
  props: ['avantageCampusTexteGros1','avantageCampusTextePetit1','avantageCampusLogo1', 'texteCampusAvantage1']
}
